import { useSearchParams } from "react-router";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RefreshCw, Calendar, WavesLadder, BarChart3 } from "lucide-react";
import { ClubPlanningPage } from "@/features/dash/home/pages/club-planning";

export function Overview() {
  const [searchParams, setSearchParams] = useSearchParams();
  // Derive activeTab directly from URL - no useState needed
  const activeTab = searchParams.get("tab") || "planning-club";

  // Update URL when tab changes (from internal tab clicks)
  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  const handleRefresh = () => {
    console.log("Refresh clicked");
  };

  return (
    <>
      <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
        <h1 className="hidden text-2xl font-bold text-gray-800 lg:block">Vue d'ensemble</h1>
        <div className="flex items-center space-x-4">
          <Button variant="outline" size="icon" className="w-10" onClick={handleRefresh}>
            <RefreshCw size={18} />
          </Button>
        </div>
      </header>

      <main className="flex-1 overflow-y-hidden px-6 pt-6">
        <div className="mb-4">
          <Tabs value={activeTab} onValueChange={handleTabChange}>
            <div className="flex items-center justify-between">
              <TabsList>
                <TabsTrigger value="planning-club" className="flex items-center gap-2 px-4 text-sm">
                  <Calendar size={16} className="shrink-0" />
                  <span className="hidden lg:inline">Planning du club</span>
                </TabsTrigger>
                <TabsTrigger value="planning-natation" className="flex items-center gap-2 px-4 text-sm" disabled>
                  <WavesLadder size={16} className="shrink-0 opacity-50" />
                  <span className="hidden opacity-50 lg:inline">Planning de la natation</span>
                </TabsTrigger>
                <TabsTrigger value="statistiques" className="flex items-center gap-2 px-4 text-sm" disabled>
                  <BarChart3 size={16} className="shrink-0 opacity-50" />
                  <span className="hidden opacity-50 lg:inline">Statistiques</span>
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="planning-club" className="mt-4">
              <ClubPlanningPage />
            </TabsContent>

            <TabsContent value="planning-natation" className="mt-4">
              <div className="flex h-64 items-center justify-center">
                <div className="text-center">
                  <WavesLadder className="mx-auto h-12 w-12 text-gray-400" />
                  <p className="mt-4 text-xl font-medium text-gray-900">Planning de la natation</p>
                  <p className="mt-1 text-sm text-gray-500">Cette fonctionnalité sera bientôt disponible.</p>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="statistiques" className="mt-4">
              <div className="flex h-64 items-center justify-center">
                <div className="text-center">
                  <BarChart3 className="mx-auto h-12 w-12 text-gray-400" />
                  <p className="mt-4 text-xl font-medium text-gray-900">Statistiques</p>
                  <p className="mt-1 text-sm text-gray-500">Cette fonctionnalité sera bientôt disponible.</p>
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </main>
    </>
  );
}
